export default {"src":"/_next/static/media/hot-tub.77328e09.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};